import {forwardRef, HTMLAttributes, ReactNode} from 'react'
import {Button, ButtonProps} from '@components/ui/button'
import {XCloseIcon} from '@components/ui/icon'
import {cn} from '@utilities/helpers'

function ModalHeader({className, ...props}: HTMLAttributes<HTMLDivElement>) {
    return (
        <div className={cn('border-b border-neutral-300 px-2 py-2.5', className)} data-slot="modal-header" {...props} />
    )
}

function ModalBody({className, ...props}: HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={cn('flex h-full flex-col gap-6 overflow-auto p-6', className)}
            data-slot="modal-body"
            {...props}
        />
    )
}

function ModalFooter({className, ...props}: HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={cn('flex justify-between border-t border-neutral-300 px-6 py-4', className)}
            data-slot="modal-footer"
            {...props}
        />
    )
}

function ModalTitle({className, ...props}: HTMLAttributes<HTMLHeadingElement>) {
    return <h3 className={cn('text-xl font-medium [&_b]:font-bold', className)} data-slot="modal-title" {...props} />
}

function ModalParagraph({className, ...props}: HTMLAttributes<HTMLParagraphElement>) {
    return <p className={cn('text-sm', className)} data-slot="modal-paragraph" {...props} />
}

const ModalCloseButton = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => (
    <Button ref={ref} variant="ghost" size="sm" shape="square" {...props}>
        <XCloseIcon />
    </Button>
))

function ModalHeaderTitle({className, children, ...props}: HTMLAttributes<HTMLDivElement> & {children: ReactNode}) {
    return (
        <div
            className={cn('relative grid items-center justify-center px-6 py-4 text-sm font-medium', className)}
            data-slot="modal-header-title"
            {...props}
        >
            {children}
        </div>
    )
}

export {ModalHeader, ModalBody, ModalFooter, ModalTitle, ModalParagraph, ModalCloseButton, ModalHeaderTitle}
